import React, { useEffect, useState } from 'react'
import { ReactImageGalleryItem } from 'react-image-gallery'
import ReactImageMagnify from 'react-image-magnify'
import 'react-image-gallery/styles/css/image-gallery.css'
import { useRouter } from 'next/router'

import styles from '../../styles/ImageMagnify.module.less'

const LARGE_IMAGE_WIDTH = 1200
const LARGE_IMAGE_HEIGHT = 1200

const ImageMagnifyComponent: React.FC<ReactImageGalleryItem> = (props) => {
  const { originalAlt, original } = props

  const router = useRouter()
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false)

  useEffect(() => {
    setIsFullscreen(router.asPath.includes('#fullscreen'))
  }, [router.asPath])

  return (
    <div
      key={isFullscreen ? 'large' : 'small'} // Use key to re-render on full screen for correct alignment
      className={styles['image-magnify-wrapper']}
    >
      <ReactImageMagnify
        {...{
          className: 'main-image-container',
          smallImage: {
            alt: originalAlt,
            isFluidWidth: true,
            src: original,
          },
          largeImage: {
            src: original,
            // intensity of the zoomed in image, lower the height width values lower will be zoom
            width: LARGE_IMAGE_WIDTH,
            height: LARGE_IMAGE_HEIGHT,
          },
          enlargedImagePosition: 'over',
          enlargedImageContainerClassName: 'enlarged-image-container',
          // Need to set inline style, as the default style overrides class styles
          enlargedImageContainerStyle: {
            height: '100%',
            width: '100%',
          },
        }}
      />
    </div>
  )
}

// Intermediary function that returns a component, because ReactImageGallery renderItem prop
// only accepts a function, not a react component.
const ImageMagnify = (props: ReactImageGalleryItem) => {
  const { originalAlt, original } = props
  return (
    <ImageMagnifyComponent
      originalAlt={originalAlt}
      original={original}
    />
  )
}
export default ImageMagnify
